module.exports = __webpack_public_path__ + "static/media/radio_selected.63dc03b8.svg";